import { ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { IntegrationParam } from '../../models/integration-param.model';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Observable, of } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IntegrationsService } from '../../services/integrations.service';
import { MatButtonModule } from '@angular/material/button';
import { IntegrationImage } from '../../models/integration-image.model';
import { ModalImageComponent } from '../modal-image/modal-image.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-images-list',
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule
  ],
  templateUrl: './images-list.component.html',
  styleUrl: './images-list.component.css'
})
export class ImagesListComponent {
  public dialogRef?: MatDialogRef<ModalImageComponent>;
  readonly dialog = inject(MatDialog);

  @Input() images: IntegrationImage[] = [];

  public params$: Observable<IntegrationParam[]> = of(this.images);

  public dataSource = new MatTableDataSource<any>(this.images);

  public displayedColumns: string[] = [
    'name',
    'file_name',
    //'val',
    'action'
  ];

  private sss: any;

  constructor(
    public integrationsService: IntegrationsService,
    public cd: ChangeDetectorRef
  ) { }

  ngOnDestroy(): void {
    this.sss.unsubscribe();
  }
  ngOnInit(): void {
    console.log("ngOnInit", this.images);

    this.dataSource = new MatTableDataSource<any>(this.images);

    this.sss = this.integrationsService.integrationChanged().subscribe({
      next: (data: any) => {
        console.log("data", data);
        this.images = data.images;
        this.dataSource = new MatTableDataSource<any>(this.images);
        this.cd.detectChanges();
      }
    });
  }

  edit(element: IntegrationParam) {
    console.log(element);
    this.openDialog(element);
  }


  /*openModal(element: IntegrationParam) {
    console.log(element);
  }*/

  deleteImage(image: IntegrationImage) {
    this.integrationsService.deleteImage(image.id)
      .subscribe({
        next: (response: any) => {
          console.log("deleteParam", response);
          this.fetchIntegration();
        }
      });
  }

  fetchIntegration() {
    this.integrationsService.fetchIntegration(this.integrationsService.currentIntegration.id)
      .subscribe({
        next: (response: any) => {
          console.log("fetchIntegration", response);
          this.integrationsService.setCurrentIntegration(response);// = response;
          //this.integrationsService.fetchIntegration(this.integrationsService.currentIntegration.id);
        }
      });
  }
  remove(element: IntegrationParam) {
    console.log(element);
    if (confirm("Na pewno usunąć " + element.name + "?")) {
      this.deleteImage(element);
    }
  }

  openDialog(image: IntegrationImage): void {
    console.log("openDialog", image);

    this.integrationsService.currentImage = image;
    this.dialogRef = this.dialog.open(ModalImageComponent, {
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe(result => {
      this.cd.detectChanges();
    });
  }

  addImage() {
    console.log("add image");
    this.openDialog(new IntegrationImage(0));
  }

}
